angular.module('app').directive('farmyPlaceholderLoader', () => {
  return {
    scope: {
      template: '@'
    },
    template: `<ng-include src="'/ng/templates/place_holder_loader/' + template + '.html'" />`
  }
});